var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageLine = function SvgMessageLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M5.378 15.833 1.666 18.75V3.333c0-.46.373-.833.833-.833h15c.46 0 .834.373.834.833V15c0 .46-.373.833-.834.833zm-.576-1.666h11.864v-10H3.333V15.32zm4.364-5.834h1.667V10H9.166zm-3.333 0h1.666V10H5.833zm6.666 0h1.667V10h-1.667z"
  })));
};
export default SvgMessageLine;